import {
    AEM_API_ERROR, AEM_API_START, AEM_API_SUCCESS
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: [],
  };
  
  export default function AEMApiReducer( 
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case AEM_API_START:
        return {
          ...state,
          loading: true,
        };
      case AEM_API_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case AEM_API_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  